import debounce from "lodash.debounce";
import { useState, useEffect } from "react";

export default function useSticky(height) {
    const isBrowser = typeof window !== "undefined";

    const [scrolled, setScrolled] = useState(
        isBrowser ? window.scrollY >= height : false
    );

    useEffect(() => {
        const scrollHandler = debounce(() => {
            setScrolled(window.scrollY >= height);
        }, 100);

        window.addEventListener("scroll", scrollHandler);

        return () => window.removeEventListener("scroll", scrollHandler);
    }, [height]);

    return scrolled;
}
